var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1)],1),_c('div',{staticClass:"footer-logos"},[(_vm.isIdentifix)?_c('div',{staticClass:"identifix-logo"}):_vm._e(),_c('div',{staticClass:"motor-logo"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }